import * as React from 'react';
import { translate } from 'components/translate-hoc';

// types
import { i18n } from 'i18next';
import { ITranslationProps } from 'types/translation';

interface IBodyCssLanguageProps extends ITranslationProps {
    i18n: i18n;
}

export class LanguageBodyClass extends React.Component<IBodyCssLanguageProps> {
    private languageClass: string;
    private LANGUAGE_CLASS_PREFIX: string = 'sitegen-';

    public componentDidMount() {
        this.languageClass = this.getFullLanguageClass();
        document.body.classList.add(this.languageClass);
    }

    public componentWillUnmount() {
        document.body.classList.remove(this.languageClass);
    }

    public componentDidUpdate() {
        const newLanguage = this.getFullLanguageClass();
        if (newLanguage && newLanguage !== this.languageClass) {
            document.body.classList.remove(this.languageClass);
            document.body.classList.add(newLanguage);
            this.languageClass = newLanguage;
        }
    }

    private getFullLanguageClass = (): string => {
        if (!(this.props.i18n && this.props.i18n.language)) {
            return '';
        }

        return this.LANGUAGE_CLASS_PREFIX + this.props.i18n.language;
    };

    public render() {
        return null;
    }
}

export default translate()(LanguageBodyClass);
